import createReactComponent from '../createReactComponent';
export default createReactComponent('facebook', 'Facebook', [["path",{"d":"M6.5 10v4h3v7h4v-7h3l1-4h-4V8c0-.545.455-1 1-1h3V3h-3c-2.723 0-5 2.277-5 5v2z","key":"svg-0"}]]);